import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { CommonService } from 'src/modules/base/services/common.service';
import { ChiefComplaintModel } from '../system-bot/system-bot.model';
declare var jQuery;
@Component({
    selector: 'app-patient-bot',
    templateUrl: './patient-bot.component.html',
    styleUrls: ['./patient-bot.component.scss'],
    standalone: false
})
export class PatientBotComponent extends MainComponent implements OnInit {
  bannerJson: any;
  result: any = {};
  fg: FormGroup;
  chiefcomplaint: ChiefComplaintModel;
  // changedCdss: boolean = false;

  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public router: Router,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef
  ) {
    super(injector, route);
  }

  ngOnInit(): void {
    this.chiefcomplaint = new ChiefComplaintModel();
    this.chiefcomplaint.defaultsetting['itemsShowLimit'] = 2;
    this.result.chief_complaints =[];
    this.result.recommended  = false;
    this.result.ordersetData = {};
    // this.bannerJson = {
    //   "jsonName": "banner_appointment",
    //   "selector": "app-patient-layout",
    //   "datasource": {
    //     "application": "patient-registration",
    //     "query_id": "GET_BY_ID",
    //     "resource": "patient"
    //   }
    // }
    this.fg = new FormGroup({
      patient_detail: new FormControl({}),
      chief_complaints: new FormControl(''),
      cdss_name: new FormControl('')
    });
  }
  ngAfterViewInit(){
    if(this['data']){
      this.result = this['data'].data;
      console.log(this.result);
      if(this.result.cdss_code){
        this.fg.controls.cdss_name.setValue(this.result.cdss_code);
      }
      // if(this.result.remarks && this.result.remarks != ''){
      //   this.result.remarks = this.result.remarks;
      //   // this.fg.controls.remarks.setValue(this.result.cdss_code);
      // }
      this.result.allQuestions = this.result.transaction;
      this.getOrderSetValue({'id' : this.result.transaction[this.result.transaction.length - 1].value})
      if (this.result.chief_complaints && this.result.chief_complaints.length > 0) {
        setTimeout(() => {
          this.fg.controls.chief_complaints.setValue(this.result.chief_complaints);
        });
      }
    }
    // this.storageService.getData('cdss_data', (data) => {
    //   if(data && data.bannerKey && this.route.snapshot.queryParams.key && data.bannerKey == this.route.snapshot.queryParams.key){
    //     this.result = data;
    //     console.log(this.result);
    //     if(this.result.selectedCDSS){
    //       this.fg.controls.cdss_name.setValue(this.result.selectedCDSS.cdss_code);
    //     }
    //     if (this.result.chief_complaints && this.result.chief_complaints.length > 0) {
    //       setTimeout(() => {
    //         this.fg.controls.chief_complaints.setValue(this.result.chief_complaints);
    //       });
    //     }
    //   }
    // })
  }
  // patientResult(event){
  //   this.result.patientData = event;
  //   this.fg.controls.patient_detail.setValue({'patient_id': event.id, 'patient_name': event.patient_name, 'patient_age': event.patient_age, 'patient_gender': event.patient_gender});
  // }
  onItemSelect(e){
    this.loader.showSpinner();
    for (let key in e) {
      if(e[key] == '')
        delete e[key];
    }
    this.result.chief_complaints.push(e);
    this.fg.controls.cdss_name.setValue('');
    this.clearCDSSPattern();
    this.findCdssName(this.result.chief_complaints);
    console.log("Event is ",e);
  }
  onItemDeselect(e){
    this.loader.showSpinner();
    for (let key in e) {
      if(e[key] == '')
        delete e[key];
    }
    this.result.chief_complaints.pop(e);
    this.fg.controls.cdss_name.setValue('');
    this.clearCDSSPattern();
    this.findCdssName(this.result.chief_complaints);
    console.log("Event is ",e);
  }
  findCdssName(complaints){
    this.loader.showSpinner();
    var complaint_Id : any = '';
    if(complaints.length > 0){
      for(var i=0;i<complaints.length;i++){
        complaint_Id = complaint_Id +complaints[i].id + '#';
      }
      complaint_Id = complaint_Id.substring(0, complaint_Id.length - 1);
      let data = {
        'filter': 'chief_complaints.id:'+complaint_Id,
        "query_id": "GET_PAGE"
      }
      this.baseService.getData(data, "", 'cdss_master', 'facility-management', 'GET_PAGE').subscribe(
        result => {
          if(result.errCode == 0 && result.resource.length > 0){
            this.result.cdssNames = result.resource;
          }
          this.loader.hideSpinner();
          console.log("Result is ", result);
        });
    }else{
      this.result.cdssNames = [];
      this.loader.hideSpinner();
    }
  }
  getTransactionData(event){
    if(event && event.target && event.target.value){
      this.fg.controls.cdss_name.setValue(event.target.value);
      let cdss_transaction = this.result.cdssNames.find(val => {
        return val.cdss_code == event.target.value;
      });
      this.result.selectedCDSS = cdss_transaction;
      this.clearCDSSPattern();
      console.log("Event is ", cdss_transaction);
      this.result.remarks = this.result.selectedCDSS.remarks;
      if(cdss_transaction && cdss_transaction.transaction){
        let transaction = cdss_transaction.transaction.find(val => {
          return val.parent_id == '';
        });
        this.addQuestion(transaction);
      }
    }
  }

  clearCDSSPattern(){
    this.result.remarks = '';
    this.result.allQuestions = [];
    this.result.questionOrder = {};
    this.result.selectedAnswers = {};
    this.result.ordersetData = {};
  }

  addQuestion(transaction){
    /****************** REMOVING ALL QUES/ANS AFTER SELECTED QUESTION 
     * (In case of reselection a previous answer) ****/
    if(this.result.questionOrder[transaction.parent_id] != undefined){
      var order = this.result.questionOrder[transaction.parent_id];
      this.result.allQuestions.length = order;
      for(let or in this.result.questionOrder){
        if(this.result.questionOrder[or] >= order){
          // this.changedCdss = true;
          delete this.result.questionOrder[or];
        }
      }
    }
    /****************** REMOVING ALL QUES/ANS AFTER SELECTED QUESTION 
     * (In case of reselection a previous answer) ****/
    this.result.questionOrder[transaction.parent_id] = Object.keys(this.result.questionOrder).length;
    console.log("trasaction",transaction);
    console.log("this.result.questionOrder",this.result.questionOrder);
    this.result.allQuestions.push(transaction);
    if(transaction.question_code != undefined){
      setTimeout(() =>{
        this.scrollTo(transaction.question_code);
      },100);
    }
  }
  

  selectAnswer(answer,question) {
      console.log("aswer",answer);
      this.result.ordersetData = {};
      this.result.recommended = false;
      this.result.selectedAnswers[question.question_code] = [answer];
      question.value = answer.id;
      let transaction = this.result.selectedCDSS.transaction.find(val => {
        return (val.answer_code == answer.id && val.parent_id == question.question_code);
      });
      this.addQuestion(transaction);
  }

  getOrderSetValue(answer,question?){
    this.result.recommended = false;
    if(question)
      question.value = answer.id;
    this.loader.showSpinner();
    let data = {
      'filter': 'id:'+answer.id,
      "query_id": "GET_PAGE"
    }
    this.baseService.getData(data, "", 'order_set', 'emr', 'GET_PAGE').subscribe(
      result => {
        if(result.errCode == 0 && result.resource.length > 0){
          this.result.ordersetData = result.resource[0];
        }
        this.loader.hideSpinner();
        console.log("Result is ", result);
      });
  }
  recommend(){
    this.result.recommended = true;
  }
  checkOrdersetData(){
    if(this.result.ordersetData && Object.keys(this.result.ordersetData).length > 0 && this['data'] == undefined ){
      return true;
    }else if(this.result.recommended && this['data'] == undefined){
      return true;
    }else{
      return false;
    }
  }
  onSubmit(){
    this.result.bannerKey = this.route.snapshot.queryParams.hasOwnProperty('key') ? this.route.snapshot.queryParams.key : '';
    console.log('Banner Info ',this.commonService.bannerInfo);
    let obj = {
      "cdss_code": this.result.selectedCDSS.cdss_code,
      "cdss_name": this.result.selectedCDSS.cdss_name,
      "remarks": this.result.remarks,
      "transaction": this.result.allQuestions,
      "chief_complaints": this.result.chief_complaints,
      "facility_id": this.appService.getOrganization().org_id,
      "encounter_id": this.commonService.bannerInfo.val.encounter_id,
      "episode_id": this.commonService.bannerInfo.val.episode_id,
      "patient_id": this.commonService.bannerInfo.val.patient_id
    }
    this.baseService.action(obj, 'add', 'emr', 'cdss').subscribe(res => {
      console.log("Resource ", res);
      if (res.errCode == 0) {
        this.alerts.success('Request Successful');
        var snapshot = this.route.snapshot;
        var params = { ...snapshot.queryParams };
        params['tab_0'] = 'prescription';
        var path = window.location.href.indexOf('editEMR') != -1 ? 'emrDesign' : 'editEMR';
        this.storageService.setData('cdss_data', this.result, () => {
          console.log('cdss saved');
        });
        if(window.location.href.indexOf('doctor_pending_appointment') > 0 ){
          this.router.navigate(['search']).then(() => {
              this.router.navigate(['emr/patientlist_format/doctor_pending_appointment/emrDesign'], {queryParams: params});
            });
        }else{
          this.router.navigate(['emr/emr_op_patient/' + path + ''], {queryParams: params});
        }
      } else
        this.alerts.error(res.message);
      this.loader.hideSpinner();
    })
   
    // this.router.navigate(['search']).then(() => {
    //   this.router.navigate(['emr/emr_op_patient/' + path + ''], {queryParams: params});
    // });
  }

  scrollTo(id){
  //   jQuery('#patient_bot').animate({
  //     scrollTop: jQuery(".cdss_"+id).offset().top
  // }, 200);
  }
}
